export const base = {
  formField: {
    borderRadius: '{border.radius.sm}',
  },
  overlay: {
    select: {
      borderRadius: '{border.radius.sm}',
    },
  },
  colorScheme: {
    light: {
      highlight: {
        background: 'var(--color-bg-tertiary-active)',
        focusBackground: 'var(--color-bg-tertiary-active-hover)',
        color: '{text.color}',
        focusColor: '{text.color}',
      },
      formField: {
        background: 'var(--color-input)',
        filledBackground: 'var(--color-input)',
        filledHoverBackground: 'var(--color-input-hover)',
        filledFocusBackground: 'var(--color-input-active)',
        borderColor: 'var(--color-input-border)',
        hoverBorderColor: 'var(--color-input-border-hover)',
        focusBorderColor: 'var(--color-input-border-active)',
        color: '{text.color}',
        iconColor: '{text.color}',
      },
      text: {
        color: 'var(--color-text)',
      },
      overlay: {
        select: {
          background: 'var(--color-bg-tertiary)',
          borderColor: 'var(--color-input-border)',
          color: 'var(--color-text-secondary)',
        },
        modal: {
          background: 'var(--color-bg)',
          borderColor: 'var(--color-border-subtle)',
          color: '{text.color}',
        },
      },
      list: {
        option: {
          focusBackground: 'var(--color-bg-tertiary-hover)',
          color: 'var(--color-text-secondary)',
          focusColor: '{text.color}',
        },
      },
    },
  },
};
